module.exports = __webpack_public_path__ + "media/app/assets/images/usb-powerbank-large-338aefd2cb075797a0e0e6d70e18fd01.jpg";